import { FontLoader } from "three";
import fontJson from "./../vendor/helvetiker_regular.typeface.json";

export const globalFont = new FontLoader().parse(fontJson);

export const defaultFontOptions = {
  font: globalFont,
  height: 0.01,
  curveSegments: 12,
  bevelEnabled: true,
  bevelSize: 0,
  bevelOffset: 0,
  bevelSegments: 0,
};
